import { a4 as showModalWithContent, Q as trapFocus, R as removeTrapFocus, a5 as isMobile, B as formatShopifyPrice } from './app-chunk-common-BPZAsnhF.js';
import { p as placeholders } from './app-bundle.vendor.js';
import { c as addToCartAndOpenCart } from './app-chunk-utils-4zL9DDjt.js';

/**
 * @param {number} discount
 * @param {Function} callback
 * @param {HTMLElement|null} triggerElement
 */
function showModalTerms(discount, callback, triggerElement = null) {
  const title = window.BOX_DISCLAIMER_TITLE;
  const text = window.BOX_DISCLAIMER_TEXT.replace(
    "[DISCOUNT]",
    String(discount)
  );

  let trigger = triggerElement;
  const wrappedCallback = () => {
    removeTrapFocus(trigger);
    callback();
  };

  /** @param {KeyboardEvent} event */

  showModalWithContent(
    text,
    {
      layout: "common",
      size: "medium",
      title: title,
      singleAction: true,
      onClose: wrappedCallback,
      modalBodyClass: "subscribe-save__terms-modal-body",
    },
    () => wrappedCallback(),
    () => wrappedCallback()
  );
  /** @type {HTMLElement|null} */
  const dialog = document.querySelector(".dialog");

  if (dialog) {
    /** @type {HTMLElement} */
    // @ts-expect-error
    const button = dialog.querySelector(".dialog__confirm-btn");
    trapFocus(dialog, button);
  }
}

const minusIcon = `
<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 11.6929H19V13.6929H5V11.6929Z" fill="black"/>
</svg>
`;

const plusIcon = `
<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 19.6929V13.6929H5V11.6929H11V5.69287H13V11.6929H19V13.6929H13V19.6929H11Z" fill="black"/>
</svg>
`;

const closeIcon = `
<svg area-hidden="true" focusable="false" role="presentation" class="icon-close" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.3231 5.2085L12.5002 11.0314L6.67725 5.2085L5.2085 6.67725L11.0314 12.5002L5.2085 18.3231L6.67725 19.7918L12.5002 13.9689L18.3231 19.7918L19.7918 18.3231L13.9689 12.5002L19.7918 6.67725L18.3231 5.2085Z" fill="black"/>
</svg>`;

const quantityUI = `
<quantity-input>
  <label for="quantity-atc-disclaimer" class="visually-hidden">Quantity</label>
  <div class="qty">
    <div class="qty__inner">
      <button class="qty__btn is-disabled" name="minus">
        ${minusIcon}<span class="visually-hidden">Decrement</span>
      </button>
      <input id="quantity-atc-disclaimer" type="number" name="quantity" class="qty__amount" min="1" value="{{ qty }}">
      <button class="qty__btn" name="plus">
      ${plusIcon}<span class="visually-hidden">Increment</span>
      </button>
    </div>
  </div>
</quantity-input>
`;

const disclaimerUI = `
<div class="modal-atc__disclaimer">
  <input type="checkbox" id="subscribe_disclaimer">
  <label for="subscribe_disclaimer">{{ disclaimerText }}</label>
</div>
`;

const modalTemplate = `
<modal-atc-disclaimer variant-id="{{ variantId }}" card-product-id="{{ cardProductId }}" data-value="onetime" style="display:none" class="modal-atc" tabindex="-1">

  <button type="button" class="modal-atc__close-icon modal-atc__close-action">
    ${closeIcon}
    <span class="icon-fallback-text">Close</span>
  </button>

  <div class="modal-atc__body">
    <subscribe-options mode="{{ mode }}">
      <fieldset>
        <div class="subs-ui">
          <label class="subs-ui__item">
            <span class="subs-ui__radio-wrapper">
              <input class="subs-ui__radio"
                     type="radio"
                     checked
                     value="onetime"
                     name="atc_modal_purchase_type_radio">
              <span class="subs-ui__radio-marker"></span>
            </span>
            <span class="subs-ui__item-text">
              <p class="subs-ui__item-text-title">One Time Purchase</p>
            </span>
          </label>

          <label class="subs-ui__item">
            <span class="subs-ui__radio-wrapper">
              <input class="subs-ui__radio"
                     type="radio"
                     value="subscription"
                     name="atc_modal_purchase_type_radio">
              <span class="subs-ui__radio-marker"></span>
            </span>
            <span class="subs-ui__item-text">
              <p class="subs-ui__item-text-title">
                Subscribe & Save {{discountAmount}}%
              </p>
            </span>
          </label>
        </div>
      </fieldset>
    </subscribe-options>

    <div class="modal-atc__freq-wrapper">
      <div class="modal-atc__freq">
        <button class="modal-atc__freq-btn is-selected" data-value="{{plan1}}">1 Month</button>
        <button class="modal-atc__freq-btn" data-value="{{plan2}}">2 Months</button>
        <button class="modal-atc__freq-btn" data-value="{{plan3}}">3 Months</button>
      </div>
    </div>
  </div>

  ${disclaimerUI}

  <form>
    <div class="modal-atc__actions">
      ${quantityUI}
      <button type="submit" class="modal-atc__action-btn modal-atc__onetime-btn button is-v2 is-solid">
        <span class="is-loader" style="background-image: url('${window.NUUN_LOADER_IMAGE}')"></span>
        <span class="is-text">Add to cart {{oneoffPrice}}</span>
      </button>
      <button type="submit" class="modal-atc__action-btn modal-atc__sub-btn button is-v2 is-solid">
        <span class="is-loader" style="background-image: url('${window.NUUN_LOADER_IMAGE}')"></span>
        <span class="is-text">Add to box <span class="is-strikeout"> {{oneoffPrice}} | </span> {{ subscriptionPrice }}</span>
      </button>
    </div>
  </form>
</modal-atc-disclaimer>
`;

/**
 * Represents data for a particular item.
 * @typedef {"onetime_default" | "subscription_default" | "subscription_only" } PurchaseTypeMode
 */

class ModalAtcDisclaimer extends HTMLElement {
  constructor() {
    super();
    this.close = this.close.bind(this);

    /** @type {import('./subscribe-options').SubscribeOptions } */
    // @ts-ignore
    this.subscribeOptions = this.querySelector("subscribe-options");

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.submitButton = this.querySelector(".modal-atc__action-btn");

    /** @type {HTMLFormElement} */
    // @ts-ignore
    this.form = this.querySelector("form");

    /** @type {HTMLInputElement} */
    // @ts-ignore
    this.termsCheckbox = document.getElementById("subscribe_disclaimer");

    /** @type {HTMLInputElement} */
    // @ts-ignore
    this.quantityInput = this.querySelector("input[name='quantity']");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.disclaimer = document.querySelector(".modal-atc__disclaimer");

    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTermsChange = this.handleTermsChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  connectedCallback() {
    this.renderOverlay();
    this.positionAndDisplay();
    this.setupEvents();
  }

  disconnectedCallback() {
    this.cleanupEvents();
  }

  setupEvents() {
    document.addEventListener("keydown", this.handleKeydown);

    // @ts-ignore
    document
      .querySelector(".modal-atc__overlay")
      .addEventListener("click", this.close);

    this.addEventListener("change", this.handleChange);

    this.termsCheckbox.addEventListener("change", this.handleTermsChange);
    this.form.addEventListener("submit", this.handleSubmit);

    // @ts-ignore
    this.querySelector(".modal-atc__close-action").addEventListener(
      "click",
      this.close
    );

    this.quantityInput.addEventListener("change", this.handleQuantityChange);

    const buttons = this.querySelectorAll(".modal-atc__freq-btn");
    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (e.target instanceof HTMLElement) {
          buttons.forEach((btn) => btn.classList.remove("is-selected"));
          e.target.classList.add("is-selected");
        }
      });
    });
  }

  cleanupEvents() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  /**
   * @param {SubmitEvent} event
   */
  handleSubmit(event) {
    event.preventDefault();
    // @ts-ignore
    const qty = this.querySelector("input[name='quantity']").valueAsNumber;
    const variantId = Number(this.getAttribute("variant-id"));
    const deliveryType = this.subscribeOptions.getAttribute("value") || "";

    if (deliveryType === "onetime") {
      this.addToCart(variantId, qty, null);
      return;
    }

    if (!this.termsCheckbox.checked) {
      this.disclaimer.classList.add("has-error");
      return;
    }

    const planId = parseInt(
      // @ts-ignore
      this.querySelector(".modal-atc__freq-btn.is-selected").dataset.value
    );

    this.addToCart(variantId, qty, planId);
  }

  /**
   * @param {string|number} variantId
   * @param {number} quantity
   * @param {number|null} sellingPlanId
   */
  addToCart(variantId, quantity, sellingPlanId) {
    this.setAttribute("disabled", "");
    const cardProduct = this.getCardProduct();
    const triggerElement = this.getAnchorTriggerElement();
    addToCartAndOpenCart(
      variantId,
      quantity,
      sellingPlanId,
      cardProduct,
      triggerElement
    ).then(() => {
      this.close();
    });
  }

  handleTermsChange() {
    this.disclaimer.classList.remove("has-error");
  }

  handleChange() {
    const deliveryType = this.subscribeOptions.getAttribute("value") || "";
    this.dataset.value = deliveryType;
    this.disclaimer.classList.remove("has-error");
  }

  renderOverlay() {
    const overlay = document.createElement("div");
    overlay.className = "modal-atc__overlay";
    document.body.appendChild(overlay);
  }

  /**
   * @returns {import("./card-product").CardProduct}
   */
  getCardProduct() {
    const cardProductId = this.getAttribute("card-product-id");
    if (!cardProductId) {
      throw new Error("No card product id found for disclaimer modal");
    }
    // @ts-ignore
    return document.getElementById(cardProductId);
  }

  /**
   * @returns {HTMLElement}
   */
  getAnchorElement() {
    const cardProduct = this.getCardProduct();
    // @ts-ignore
    return cardProduct.querySelector("[data-disclaimer-anchor]");
  }

  getAnchorTriggerElement() {
    const anchor = this.getAnchorElement();
    const button = anchor.querySelector("button");
    return button;
  }

  positionAndDisplay() {
    const docWidth = document.body.offsetWidth;
    const element = this.getAnchorElement();
    const parentLeft = element.getBoundingClientRect().left;
    const modalWidth = 365;
    const overflowAmount = Math.max(0, parentLeft + modalWidth - docWidth);

    if (isMobile() === false && overflowAmount > 0) {
      // Push left with a small padding
      this.style.left = "auto";
      this.style.right = "0";
    }

    this.style.display = "block";

    window.setTimeout(() => {
      /** @type {HTMLElement} */
      // @ts-expect-error
      const closeBtn = this.querySelector(".modal-atc__close-action");
      this.classList.add("is-opening");
      trapFocus(this, closeBtn, true);
    }, 1);
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  handleQuantityChange() {
    const qty = this.quantityInput.value;
    const card = this.getCardProduct();
    // @ts-ignore
    card.querySelector("input[name=quantity]").value = qty;
  }

  close() {
    /** @type {HTMLElement} */
    // @ts-ignore
    const overlay = document.querySelector(".modal-atc__overlay");

    overlay.classList.add("is-closing");
    this.classList.remove("is-opening");
    this.classList.add("is-closing");

    const button = this.getAnchorTriggerElement();

    if (button) {
      button.focus();
    }

    this.addEventListener("animationend", () => {
      // @ts-ignore
      this.parentNode.removeChild(this);
      document.body.removeChild(overlay);
    });
  }

  static removeExisting() {
    /** @type {HTMLElement|null} */
    const existing = document.querySelector("modal-atc-disclaimer");
    if (existing) {
      // @ts-ignore
      existing.parentNode.removeChild(existing);
    }
  }

  /**
   * @param {HTMLElement} productElement} The container card product
   * @param {import("../types/products").Product} product
   * @param {import("../types/products").ProductVariant} variant
   * @param {number} qty
   * @param {PurchaseTypeMode} [mode]
   */
  static show(productElement, product, variant, qty, mode = "onetime_default") {
    this.removeExisting();

    /** @type {HTMLElement|null} */
    const element = productElement.querySelector("[data-disclaimer-anchor]");

    if (!element) {
      console.error(
        "[Modal ATC Disclaimer] Element must have [data-disclaimer-anchor]",
        this
      );
      return;
    }

    const plans = product.selling_plan_groups[0].selling_plans;
    const subscriptionPrice =
      variant.selling_plan_allocations[0].per_delivery_price;

    const discountAmount =
      // @ts-ignore
      document.querySelector("main").dataset.subscriptionDiscount;

    if (!productElement.id) {
      console.error("[Modal ATC Disclaimer] Element expects an id", this);
    }

    const options = {
      cardProductId: productElement.id,
      oneoffPrice: formatShopifyPrice(variant.price),
      subscriptionPrice: formatShopifyPrice(subscriptionPrice),
      productId: product.id,
      variantId: variant.id,
      discountAmount: discountAmount,
      disclaimerText: window.BOX_DISCLAIMER_TEXT.replace(
        "[DISCOUNT]",
        discountAmount || ""
      ),
      mode: mode,
      plan1: plans[0].id,
      plan2: plans[1].id,
      plan3: plans[2].id,
      qty,
    };

    const data = { ...options, content: "" };
    const tmpl = modalTemplate;
    const modalHTML = placeholders(tmpl, data);

    element.insertAdjacentHTML("beforeend", modalHTML);
  }
}

if (!customElements.get("modal-atc-disclaimer")) {
  customElements.define("modal-atc-disclaimer", ModalAtcDisclaimer);
}

export { ModalAtcDisclaimer as M, showModalTerms as s };
